var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',[(!_vm.currentComponent)?_c('Loader',{staticClass:"mr-2 mt-6"}):_c(_vm.currentComponent,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }